var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-login"},[_c('div',{staticClass:"c-login__body"},[_c('forgot-password-email-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }